module.exports = __webpack_public_path__ + "static/media/75804a4e.jpg";